<h3 mat-dialog-title>Instruções para Whatsapp</h3>
<div mat-dialog-content>
  <div class="dialog-inicial" *ngIf="dialogInicial">
    <div class="mb-3">{{data.midia.texto}}</div>
    <div class="d-flex">
      <div class="imagem col">
        <img
          id="myImage"
          class="w-100"
          [src]="getImagem(data.midia.imagem_midia)"
        />
      </div>
      <div class="texto col" *ngIf="data.midia.imagem_midia">
        <a
          class="btn btn-link"
          [href]="data.midia.imagem_midia"
          target="_blank"
          download
        >
          Download
        </a>

        <a
          class="btn btn-link"
          (click)="copyImage(data.midia.imagem_midia)"
          target="_blank"
          *ngIf="!isFormat(data.midia.imagem_midia, ['pdf', 'gif', 'webp'])"
        >
          Copiar Imagem
        </a>
      </div>
    </div>

    <div
      *ngIf="isFormat(data.midia.imagem_midia, ['pdf', 'gif', 'webp'])"
      class="alert alert-warning mt-3"
    >
      Não é possível copiar imagens no formato
      <span *ngIf="isFormat(data.midia.imagem_midia, ['pdf'])">PDF</span
      ><span *ngIf="isFormat(data.midia.imagem_midia, ['gif'])">GIF</span
      ><span *ngIf="isFormat(data.midia.imagem_midia, ['webp'])">WEBP</span>.
      Poderá fazer o download.
    </div>

    <div class="mt-3">
      <div>
        <a
          (click)="dialogInicial = false; showConfirmacao = true; openChat()"
          class="btn btn-block mb-2 text-uppercase"
          [ngClass]="'btn-action-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()"
          [href]="whatsAppLink"
        >
          continuar para whatsapp
        </a>
        <div *ngIf="error" class="alert alert-danger">
          Houve um erro ao realizar sua ativação, tente novamente
        </div>
        <button
          (click)="close()"
          class="btn btn-block mb-2 text-uppercase"
          [ngClass]="'btn-cancel-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()"
        >
          voltar
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="showConfirmacao">
    <p>Mensagem enviada?</p>
    <button
      *ngIf="data.modoCampanha"
      (click)="mainActivation()"
      class="btn btn-block mb-2 text-uppercase"
      [ngClass]="'btn-cinza-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()"
    >
      SIM, PRÓXIMO CLIENTE
    </button>
    <button
      *ngIf="!data.ativacaoEspontanea"
      (click)="securityService.yes(this.data.ativacao, this.data.midia.tipo_midia)"
      class="btn btn-block mb-2 text-uppercase"
      [ngClass]="'btn-action-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()"
    >
      SIM
    </button>
    <button
      *ngIf="data.ativacaoEspontanea"
      (click)="confirmar('ativou-next')"
      class="btn btn-block mb-2 text-uppercase"
      [ngClass]="'btn-action-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()"
    >
      SIM, Finalizar contato
    </button>
    <button
      (click)="naoEnviouZap(); showConfirmacao = false; dialogAtivacaoMalSucedida = true"
      class="btn btn-block mb-2 text-uppercase"
      [ngClass]="'btn-action-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()"
    >
      NÃO
    </button>
    <div *ngIf="!jaTentouDuasVersoes">
      <p>Se o whatsapp não abriu, abra aqui:</p>
      <button
        (click)="secondLinkHandler(); jaTentouDuasVersoes = true"
        class="btn btn-block mb-2 text-uppercase"
        [ngClass]="'btn-action-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()"
      >
        whatsapp
      </button>
    </div>
  </div>

  <div *ngIf="dialogAtivacaoMalSucedida">
    <p>Porque não enviou a mensagem?</p>
    <button
      (click)="ativacaoMalSucedida('número-inválido')"
      class="btn btn-block mb-2 text-uppercase"
      [ngClass]="'btn-action-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()"
    >
      Whatsapp não reconhece o número
    </button>
    <button
      (click)="ativacaoMalSucedida('outro')"
      class="btn btn-block mb-2 text-uppercase"
      [ngClass]="'btn-action-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()"
    >
      Outro
    </button>
    <button
      (click)="showConfirmacao = true; dialogAtivacaoMalSucedida = false"
      class="btn btn-block mb-2 text-uppercase"
      [ngClass]="'btn-action-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()"
    >
      Voltar
    </button>
  </div>
</div>
